import { AbstractEntityMapper } from '@pf/shared-services';
import {
    UserPositionCreate,
    UserPositionDto,
    UserPositionRead,
    UserPositionSearchParams,
} from '../../entities/user-position.dto';
import { Injectable } from '@angular/core';
import { PlatformCoreMapper } from '../platform-core.mapper';
import { UserPositionMetadataMap } from './user-position.mapping-profile';

@Injectable()
export class UserPositionMapper extends AbstractEntityMapper<
    UserPositionRead,
    UserPositionCreate,
    UserPositionDto,
    UserPositionSearchParams
> {
    constructor() {
        super(
            UserPositionDto,
            PlatformCoreMapper,
            UserPositionMetadataMap.symbols
        );
    }
}
